import type { Lohnabrechnungseinstellungen } from './Lohnabrechnungseinstellungen';

export class Standort {
  constructor({
    uid,
    name,
    storenummer,
    lohnabrechnungseinstellungen,
  }: {
    uid: string;
    name: string;
    storenummer?: string | null;
    lohnabrechnungseinstellungen: Lohnabrechnungseinstellungen;
  }) {
    this.uid = uid;
    this.name = name;
    this.storenummer = storenummer;
    this.lohnabrechnungseinstellungen = lohnabrechnungseinstellungen;
  }

  uid: string;
  name: string;
  storenummer?: string | null;
  lohnabrechnungseinstellungen: Lohnabrechnungseinstellungen;
}
